import type { IncidentHistoryStateAfterResponse } from '@prerender/diagnostics-api';

import { ABSENT_VALUE } from './formatMeasuredValue';
import { affectedDomainsLabel } from './historyLabels';
import IncidentStatusTag from './IncidentStatusTag';
import SeverityTag from './SeverityTag';

type HistoryStateAfterProps = {
  stateAfter: IncidentHistoryStateAfterResponse | null;
};

function HistoryStateAfter({ stateAfter }: HistoryStateAfterProps) {
  if (stateAfter === null) {
    return <>{ABSENT_VALUE}</>;
  }

  const { affectedDomainCount, severity, status } = stateAfter;

  return (
    <>
      {affectedDomainsLabel(affectedDomainCount)}
      {affectedDomainCount > 0 && (
        <>
          {' '}
          <SeverityTag severity={severity} />
        </>
      )}
      {status !== 'active' && (
        <>
          {' '}
          <IncidentStatusTag status={status} />
        </>
      )}
    </>
  );
}

export default HistoryStateAfter;
